export const isBuyApp = () => {
  return isAppType('buy');
};

export const isDeliverApp = () => {
  return isAppType('deliver');
};

export const isSellApp = () => {
  return isAppType('sell');
};

export const isToolsApp = () => {
  return isAppType('tools');
};

const isAppType = urlPrefix => {
  return new RegExp(`^/${urlPrefix}`).test(window.location.pathname);
};

// The NextGen UI is served under /app in production. In local dev it runs as a
// separate server, addressed via VITE_NGROK_UI_APP_URL (e.g. an ngrok tunnel)
// or localhost:8080 by default.
export const newAppBaseUrl = () => {
  const base = import.meta.env.DEV
    ? import.meta.env.VITE_NGROK_UI_APP_URL || 'http://localhost:8080'
    : '/app';
  return base.replace(/\/+$/, '');
};

export const resolveNewAppUrl = path => `${newAppBaseUrl()}${path}`;
